import { styled } from "styled-components";

import { Avatar } from "../Avatar";
import { textOverflowStyles } from "../../styles";

export const Title = styled.div(({ theme }) => ({
  width: "100%",
  margin: 0,
  fontSize: theme.fontSizes["2"], // 16px
  fontWeight: theme.fontWeights["2"], // 600
  // Single-line box: line-height matches the fixed height so the title cannot
  // be clipped by an inherited line-height.
  height: theme.lineHeights["3"], // 24px
  lineHeight: theme.lineHeights["3"], // 24px
  color: theme.colors.black,
  ...(textOverflowStyles as any), // not quite sure how to get the correct typing here
}));

export const Description = styled.p(({ theme }) => ({
  display: "-webkit-box",
  margin: 0,
  color: theme.colors.grayDark,
  "-webkit-line-clamp": 2,
  "-webkit-box-orient": "vertical",
  overflow: "hidden",
  wordBreak: "break-word",
}));

export const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "48px 32px",
  textAlign: "center",

  [`& ${Avatar.Container}`]: {
    marginBottom: theme.space["4"], // 16px
  },

  [`& ${Title}`]: {
    marginBottom: 8,
  },
}));
